export default __webpack_public_path__ + "static/media/01Khajuraho.1dbae841.jpg";